module.exports = __webpack_public_path__ + "static/media/exploration.eace69be.png";